export default __webpack_public_path__ + "static/media/card.ed2c6a72.jpg";